import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* getRequest(action) {
    try {
        const ids = action.payload;
        const url = `${config.api.paths.auditResendAssignmentEmail}?${ids}`;
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On audit resend assignment email get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

function* post(action) {
    const { audits } = action.payload;
    try {
        const { data } = yield call(
            http.authorized.post,
            config.api.paths.auditResendAssignmentEmail,
            { audits }
        );
        yield put(actionCreators.postSuccess(data));
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On audit resend assignment email post:", { error });
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.AUDIT_RESEND_AUDIT_EMAIL_POST_REQUEST, post),
        takeLatest(
            actionTypes.AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_REQUEST,
            getRequest
        )
    ]);
}
